<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import { haptic } from '@/lib/telegram'
import { useT } from '@/lib/i18n'

const route = useRoute()
const router = useRouter()
const t = useT()

const tabs = computed(() => [
  { name: t.value('nav.home'),      to: '/dashboard', match: ['dashboard'] },
  { name: t.value('nav.markets'),   to: '/markets',   match: ['markets'] },
  { name: t.value('nav.watchlist'), to: '/watchlist', match: ['watchlist'] },
  { name: t.value('nav.profile'),   to: '/profile',   match: ['profile'] },
])

const activeIndex = computed(() => {
  const i = tabs.value.findIndex((tab) => tab.match.some((m) => String(route.name).startsWith(m)))
  return i >= 0 ? i : -1
})

function go(to: string) {
  haptic('light')
  if (route.path !== to) router.push(to)
}
</script>

<template>
  <nav class="fixed bottom-0 inset-x-0 mx-auto max-w-[460px] z-40 px-4 pt-2 pb-5 flex gap-1.5 backdrop-blur-xl"
       style="padding-bottom: max(20px, env(safe-area-inset-bottom, 0px), var(--tg-safe-bottom, 0px)); background: linear-gradient(180deg, rgba(7,9,18,0), rgba(7,9,18,0.96) 30%)">
    <button
      v-for="(tab, i) in tabs"
      :key="tab.to"
      class="flex-1 flex flex-col items-center gap-0.5 py-1.5 relative rounded-xl text-[10.5px] font-medium"
      :class="activeIndex === i ? 'text-pri-300' : 'text-text-lo'"
      @click="go(tab.to)"
    >
      <span
        v-if="activeIndex === i"
        class="absolute top-2 w-6 h-[3px] rounded-full bg-grad-brand"
      />
      <svg v-if="i === 0" class="w-[22px] h-[22px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12l9-8 9 8M5 10v10h14V10" stroke-linejoin="round" /></svg>
      <svg v-else-if="i === 1" class="w-[22px] h-[22px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18M7 14l4-4 4 4 5-6" /></svg>
      <svg v-else-if="i === 2" class="w-[22px] h-[22px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l3 7h7l-6 4 2 8-6-4-6 4 2-8-6-4h7z" stroke-linejoin="round" /></svg>
      <svg v-else class="w-[22px] h-[22px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></svg>
      {{ tab.name }}
    </button>
  </nav>
</template>
